export const SET_ID_DOCUMENT_TYPE = 'SET_ID_DOCUMENT_TYPE'
export const SET_ID_ISSUING_COUNTRY = 'SET_ID_ISSUING_COUNTRY'
export const RESET_ID_ISSUING_COUNTRY = 'RESET_ID_ISSUING_COUNTRY'
export const SET_POA_DOCUMENT_TYPE = 'SET_POA_DOCUMENT_TYPE'
export const SET_ROOM_ID = 'SET_ROOM_ID'
export const SET_SOCKET = 'SET_SOCKET'
export const SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER'
export const SET_CLIENT_SUCCESS = 'SET_CLIENT_SUCCESS'
export const MOBILE_CONNECTED = 'MOBILE_CONNECTED'
export const ACCEPT_TERMS = 'ACCEPT_TERMS'
export const SET_NAVIGATION_DISABLED = 'SET_NAVIGATION_DISABLED'
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'
export const SET_DEVICE_HAS_CAMERA_SUPPORT = 'SET_DEVICE_HAS_CAMERA_SUPPORT'
export const SET_URLS = 'SET_URLS'
export const HIDE_ONFIDO_LOGO = 'HIDE_ONFIDO_LOGO'
export const SHOW_COBRANDING = 'SHOW_COBRANDING'
export const RETRY_FOR_IMAGE_QUALITY = 'RETRY_FOR_IMAGE_QUALITY'
export const RESET_IMAGE_QUALITY_RETRIES = 'RESET_IMAGE_QUALITY_RETRIES'

export const CAPTURE_CREATE = 'CAPTURE_CREATE'
export const CAPTURE_DELETE = 'CAPTURE_DELETE'
export const SET_CAPTURE_METADATA = 'SET_CAPTURE_METADATA'

export const RESET_STORE = 'RESET_STORE'
